<template>
    <div class="row">
        <div class="col-12 mb-3">
            <div class="row">
                <div class="col-12 order-0 col-sm flex-sm-grow-0 text-sm-right order-sm-1 col-lg-3 flex-lg-grow-1 order-lg-2">
                    <button class="btn btn-warning mb-3 mb-sm-0" @click="openFileModal(false)">
                        <font-awesome-icon icon="upload"/>&nbsp;&nbsp;&nbsp;Upload file
                    </button>
                </div>
                <div class="col-12 order-1 col-sm order-sm-0 col-lg-3" v-if="files.length">
                    <select name="tags"
                            class="form-control"
                            v-model="selectedTag"
                            @change="addTagFilter">
                        <option value="-1" disabled selected>choose filter tag</option>
                        <option v-for="(tag, index) in tags"
                                :key="`unusedTags${index}`"
                                :value="index">{{tag}}
                        </option>
                    </select>
                </div>
                <div class="col-12 order-2 col-sm-12 order-sm-2 order-lg-1 col-lg-6 h5 mb-0 pb-1 align-self-center" v-if="files.length">
                    <span class="badge badge-primary ml-1"
                          v-for="(tag, index) in selectedTags"
                          :key="`usedTags${index}`">{{tag}}&nbsp;&nbsp;&nbsp;<a href="#!"
                                                                                @click.prevent="removeTag(index)"
                                                                                class="qf-color-white"><font-awesome-icon
                            icon="times"/></a></span>
                </div>
            </div>
        </div>
        <div class="col-12 mb-3">
            <div class="table-responsive">
                <table class="qf-trademarks-table table qf-table">
                    <tbody>
                    <tr v-for="(document, index) in filteredFiles" :key="`file${index}`"
                        class="qf-h-60px">
                        <td class="qf-table-control">
                            <font-awesome-icon icon="file"/>
                        </td>
                        <td>
                            {{document.description}}
                        </td>
                        <td>
                            <a :href="downloadUrl(document.id)" download>
                                <font-awesome-icon icon="download"/>&nbsp;{{document.original_name}}</a>
                        </td>
                        <td>
                            <a href="#!" class="badge badge-primary ml-1"
                               v-for="(tag, tagIndex) in document.tags"
                               :key="`tag${index}${tagIndex}`"
                               :class="{'qf-highlight': selectedTags.includes(tag.name)}"
                               @click.prevent="addTagTable(tag.name)">{{tag.name}}</a>
                        </td>
                        <td class="qf-table-control" colspan="2" v-if="loaders.includes(document.id)">
                            <font-awesome-icon icon="spinner" class="fa-spin"/>
                        </td>
                        <td v-if="!loaders.includes(document.id)" class="qf-table-control">
                            <a href="#!" @click.prevent="openFileModal(document)">
                                <font-awesome-icon icon="pen"/>
                            </a>
                        </td>
                        <td class="qf-table-control"
                            v-if="!loaders.includes(document.id) && $store.state.loggedUser.roles[0] === 'ROLE_MAIN'">
                            <a href="#!" @click.prevent="deleteFile(document.id)">
                                <font-awesome-icon icon="trash-alt"/>
                            </a>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <b-modal id="add-file-modal"
                 size="lg"
                 v-model="showAddFileModal"
                 title="Add File"
                 :hide-footer="true"
                 :hide-header="true">
            <upload-file-modal v-if="showAddFileModal"
                               :id="id"
                               :file="file"
                               @closeFileModal="closeFileModal"
                               @addFile="addFile"></upload-file-modal>
        </b-modal>
    </div>
</template>
<script>
    import UploadFileModal from "./UploadFileModal"

    export default {
        name: "BrandFiles",
        components: {
            UploadFileModal
        },
        props: {
            files: Array,
            id: [String, Number],
            brand: Object
        },
        computed: {
            tags() {
                return this.$store.state.tags.filter(item => {
                    return !this.selectedTags.includes(item);
                });
            },
            filteredFiles() {
                return this.files.filter(item => {
                    let filtered = 0;
                    if (this.selectedTags.length) {
                        item.tags.forEach(item => {
                            if (this.selectedTags.includes(item.name)) {
                                filtered++
                            }
                        });
                    } else {
                        filtered = 0
                    }
                    return filtered === this.selectedTags.length;
                });
            }
        },
        data() {
            return {
                loading: true,
                loaders: [],
                showAddFileModal: false,
                selectedTag: -1,
                selectedTags: [],
                file: false
            }
        },
        methods: {
            openFileModal(file = false) {
                this.file = file;
                this.showAddFileModal = !this.showAddFileModal
            },
            addTagFilter() {
                this.selectedTags.push(this.tags[this.selectedTag])
                this.selectedTag = -1;
            },
            addTagTable(tag) {
                let tagIndex = this.selectedTags.findIndex(item => {
                    return item === tag
                });
                if (tagIndex === -1) {
                    this.selectedTags.push(tag);
                } else {
                    this.selectedTags.splice(tagIndex, 1)
                }
            },
            removeTag(index) {
                this.selectedTags.splice(index, 1);
            },
            downloadUrl(value) {
                let baseUrl = process.env.VUE_APP_API_URL;
                if (value === '') {
                    return '';
                }
                return `${baseUrl}brand/${this.id}/document/${value}?access_token=${localStorage.getItem('user-token')}`;
            },
            addFile(file) {
                this.$emit('addFile', file);
                this.closeFileModal();
            },
            deleteFile(id) {
                if (!this.loaders.includes(id)) {
                    this.loaders.push(id);
                    this.$store.dispatch('deleteFile', {brandId: this.id, documentId: id}).then(() => {
                        let loaderIndex = this.loaders.findIndex(item => {
                            return item === id;
                        });
                        if (loaderIndex !== -1) {
                            this.loaders.splice(loaderIndex, 1);
                        }
                        this.$emit('removeFile', id);
                    });
                }
            },
            closeFileModal() {
                this.showAddFileModal = false
            }
        }

    }
</script>

<style scoped>
    .fq-file-input {
        display: none;
    }

    .fq-file-input-label {
        margin: 0;
        display: block;
        width: 100%;
        height: 56px;
        background: #ffffff;
        text-align: center;
        text-transform: uppercase;
        cursor: pointer;
        transition: 0.3s all ease-in-out;
    }

    .fq-file-input-label:hover {
        background: #ebebeb;
    }

    .fq-file-input-label .qf-file-input-text {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        text-align: center;
    }

    .qf-progress {
        position: absolute;
        display: block;
        height: 100%;
        width: 0;
        top: 0;
        left: 0;
        background: #f7c000;
        transition: 0.3s all linear;
    }

    .qf-table > tbody > tr {
        font-size: 16px;
    }

    .qf-table-control {
        width: 20px;
    }

</style>
